module.exports = __webpack_public_path__ + "static/img/client_background.a2d87c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client_background.png
// module id = TvLU
// module chunks = 1